import { NAME } from "./constants";

export const isLoading = (state) => {
  return state.pages[NAME].isLoading;
};

export const getActiveTab = (state) => {
  return state.pages[NAME].activeTab;
};

export const getContentOrders = (state) => {
  return state.pages[NAME].contentOrders;
};

export const getContentOrdersThatNeedEditing = (state) => {
  return state.pages[NAME].contentOrders.needsEditing;
};

export const getContentOrdersThatNeedEditingFiltered = (state) => {
  const contentOrders = state.pages[NAME].contentOrders.needsEditing;
  const filterName = state.pages[NAME].contentOrdersFilter.filterName;

  if (filterName) {
    return contentOrders.filter(order =>
      order.meta.project.meta.parent.local.business.name.trim() === filterName
    );
  }

  return contentOrders;
};

export const getContentOrdersThatNeedPosting = (state) => {
  return state.pages[NAME].contentOrders.needsPosting;
};

export const getContentOrdersThatNeedPostingFiltered = (state) => {
  const contentOrders = state.pages[NAME].contentOrders.needsPosting;
  const filterName = state.pages[NAME].contentOrdersFilter.filterName;

  if (filterName) {
    return contentOrders.filter(order =>
      order.meta.project.meta.parent.local.business.name.trim() === filterName
    );
  }

  return contentOrders;
};

export const getContentOrdersBeingWritten = (state) => {
  return state.pages[NAME].contentOrders.inQueue;
};

export const getContentOrdersBeingWrittenFiltered = (state) => {
  const contentOrders = state.pages[NAME].contentOrders.inQueue;
  const filterName = state.pages[NAME].contentOrdersFilter.filterName;

  if (filterName) {
    return contentOrders.filter(order =>
      order.meta.project.meta.parent.local.business.name.trim() === filterName
    );
  }

  return contentOrders;
};

export const getRecentlyPublishedContentOrders = (state) => {
  const sortedArray = state.pages[NAME].contentOrders.recentlyPublished;
  sortedArray.sort(function compare(a, b) {
    var dateA = new Date(a.meta.publishedOn);
    var dateB = new Date(b.meta.publishedOn);
    return dateB - dateA;
  });
  return sortedArray;
};

export const getRecentlyPublishedContentOrdersFiltered = (state) => {
  const contentOrders = state.pages[NAME].contentOrders.recentlyPublished;
  const filterName = state.pages[NAME].contentOrdersFilter.filterName;

  let sortedArray = contentOrders;

  if (filterName) {
    sortedArray = contentOrders.filter(order =>
      order.meta.project.meta.parent.local.business.name.trim() === filterName
    );
  }

  sortedArray.sort(function compare(a, b) {
    var dateA = new Date(a.meta.publishedOn);
    var dateB = new Date(b.meta.publishedOn);
    return dateB - dateA;
  });

  return sortedArray;
};

export const getFilterName = (state) => {
  return state.pages[NAME].contentOrdersFilter.filterName;
}
